"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.togglePauseDialog = exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _Button = _interopRequireDefault(require("../common/components/Button"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _react = _interopRequireDefault(require("react"));

var _StoreComponent2 = _interopRequireDefault(require("../KESI2/Stores/StoreComponent"));

var _PauseHelper = _interopRequireDefault(require("./PauseHelper.scss"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _DateTimeHelper = require("./DateTimeHelper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var updateFn = null;

var PauseHelper = /*#__PURE__*/function (_StoreComponent) {
  (0, _inherits2["default"])(PauseHelper, _StoreComponent);

  var _super = _createSuper(PauseHelper);

  function PauseHelper(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, PauseHelper);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setDay", function (day) {
      _this.setState({
        pauseDays: day
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setVisible", function () {
      _this.setState({
        visible: !_this.state.visible
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setPause", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(days) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _DateTimeHelper.setPause)(days);

              case 2:
                _this.setVisible();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "render", function () {
      if (!_this.state.visible) return /*#__PURE__*/_react["default"].createElement("div", {
        id: "pauseHelper"
      });
      var possibleDays = (0, _toConsumableArray2["default"])(Array(10 + 1).keys());
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          zIndex: 35002,
          position: 'absolute',
          left: 0,
          top: 0,
          height: '100%',
          width: '100%'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
        className: _PauseHelper["default"].closeIcon,
        onClick: function onClick() {
          return _this.setVisible();
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _PauseHelper["default"].container
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _PauseHelper["default"].title
      }, "Schichtbox pausieren"), /*#__PURE__*/_react["default"].createElement("div", null, "Hier kannst Du die Schichtbox pausieren, wenn Du einmal keine Zeit hast. Danach geht es normal weiter!"), /*#__PURE__*/_react["default"].createElement("div", {
        className: _PauseHelper["default"].subtitle
      }, "Zeitraum w\xE4hlen"), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
        className: _PauseHelper["default"].select,
        onChange: function onChange(evt) {
          return _this.setDay(evt.target.value);
        },
        MenuProps: {
          style: {
            zIndex: 35005
          }
        },
        value: _this.state.pauseDays
      }, possibleDays.map(function (dayNumber) {
        return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
          key: dayNumber,
          value: dayNumber
        }, dayNumber);
      })), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: function onClick() {
          return _this.setPause(_this.state.pauseDays);
        },
        className: _PauseHelper["default"].button
      }, "".concat(_this.state.pauseDays, " ").concat(_this.state.pauseDays === 1 ? 'Tag' : 'Tage', " pausieren"))));
    });
    _this.state = {
      pauseDays: 1,
      visible: false
    };
    updateFn = _this.setVisible;
    return _this;
  }

  return PauseHelper;
}(_StoreComponent2["default"]);

exports["default"] = PauseHelper;

var togglePauseDialog = function togglePauseDialog() {
  console.log('showPauseDialog');
  updateFn();
}; // const possibleDays = [...Array(10 + 1).keys()]
// const el = document.getElementById('pauseHelper')
// )
// }


exports.togglePauseDialog = togglePauseDialog;